const AUTH_BYPASS_OPTOUT_KEY = 'anysync:disable-auth-bypass';
const AUTH_BYPASS_OPTOUT_HEADER = 'X-Anysync-Disable-Auth-Bypass';
const STAGING_HOSTNAME_PREFIX = 'staging.anysync-dashboard.pages.dev';
type StagingAuthBypassPolicy = 'force-bypass' | 'force-opt-out' | 'session-controlled';

function canUseSessionStorage() {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
}

export function isAuthBypassOptedOut() {
  if (!canUseSessionStorage()) {
    return false;
  }

  const stagingRoutePolicy = getStagingRoutePolicy();

  if (stagingRoutePolicy === 'force-bypass') {
    return false;
  }

  if (stagingRoutePolicy === 'force-opt-out') {
    return true;
  }

  return window.sessionStorage.getItem(AUTH_BYPASS_OPTOUT_KEY) === '1';
}

export function setAuthBypassOptOut() {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.setItem(AUTH_BYPASS_OPTOUT_KEY, '1');
}

export function clearAuthBypassOptOut() {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(AUTH_BYPASS_OPTOUT_KEY);
}

export function buildAuthBypassHeaders() {
  if (!isAuthBypassOptedOut()) {
    return {} as Record<string, string>;
  }

  return {
    [AUTH_BYPASS_OPTOUT_HEADER]: '1',
  } satisfies Record<string, string>;
}

function getStagingRoutePolicy(): StagingAuthBypassPolicy {
  if (typeof window === 'undefined') {
    return 'session-controlled';
  }

  if (!isStagingPagesHost(window.location.hostname)) {
    return 'session-controlled';
  }

  if (window.location.pathname === '/login') {
    return 'force-bypass';
  }

  if (isProtectedAppRoute(window.location.pathname)) {
    return 'session-controlled';
  }

  return 'force-opt-out';
}

function isProtectedAppRoute(pathname: string) {
  return pathname === '/projects' || pathname.startsWith('/projects/') || pathname.startsWith('/settings');
}

function isStagingPagesHost(hostname: string) {
  const normalizedHostname = hostname.toLowerCase();
  return (
    normalizedHostname === STAGING_HOSTNAME_PREFIX ||
    normalizedHostname.endsWith('.anysync-dashboard.pages.dev')
  );
}
